
import Vue, { PropType } from 'vue'

import Basket from 'icons/basket-cart--desktop.svg?inline'
import RPHButton from 'rph/atoms/RPHButton/index.vue'
import ProductCounter from '~/components/atoms/ProductCounter.vue'
import { IProduct } from 'types/DTO/products'

export default Vue.extend({
  name: 'RPHProductAnalog',
  components: { RPHButton, Basket, ProductCounter },
  data() {
    return {
      basket: false,
      value: 1,
      expProductModalActive: false,
    }
  },
  props: {
    analogData: {
      type: Object as PropType<IProduct>,
      default: Object,
    },

    additionalKey: {
      type: String,
      default: 'category',
    },
  },
  computed: {
    analogLink(): string {
      return '/product/' + this.$props.analogData.slug
    },
    basketList(): any {
      return this.$store.getters['rph-basket/basketList']
    },
    productAmount: {
      get(): number {
        const product = this.basketList.find(
          (p: any) => p.id === this.analogData.id && p.selected_price === this.availablePrice,
        )
        return product !== undefined && product.count ? product.count : this.value
      },
      set(val: number) {
        this.value = val
      },
    },
    availablePrice(): string {
      return this.$services.price.getDefaultPrice(this.$props.analogData.prices)
    },
    productPrice(): any {
      return this.$services.productInBasket.getPrice(this.analogData, 'default_state')
    },
    productOldPrice(): number {
      return this.$services.price.getOldPrice(this.productPrice)
    },
    basketId(): string {
      return this.$store.getters['rph-basket/basketId']
    },
    pharmacyId(): number | undefined {
      return this.analogData.prices[this.availablePrice]?.pharmacy_id
    },
    providerId(): any {
      const providerId =
        this.availablePrice === 'standard' || this.availablePrice === 'hot_price'
          ? this.analogData.prices[this.availablePrice].provider_id
          : ''
      return providerId || ''
    },
    isBasket(): boolean {
      const idArr = this.$store.getters['rph-basket/basketProductsId']
      return idArr.includes(this.$props.analogData.id)
    },
    isHotPriceAvailable(): boolean {
      return this.$services.price
        .getAvailablePrices(this.$props.analogData.prices)
        .includes('hot_price')
    },
  },
  methods: {
    async addProductInBasket(): Promise<void> {
      const { isHot, pharmacyId, providerId } = this.$services.productInBasket.getPharmacyId(
        this.$props.analogData,
      )
      await this.$services.productInBasket.addProductInBasket(
        String(this.basketId),
        this.$props.analogData?.id,
        1,
        pharmacyId,
        isHot,
        providerId,
        this.additionalKey,
      )
    },
    async setProductAmount(
      id: number,
      product_id: number,
      val: number,
      pharmacy_id: number,
      provider_id: number,
    ) {
      const params = new URLSearchParams()
      params.append('count', String(val))
      if (val === 0) {
        await this.$services.productInBasket.deleteProductInBasket(
          String(id),
          String(product_id),
          pharmacy_id,
          provider_id,
        )
      } else {
        await this.$store.dispatch('rph-basket/changeCount', {
          id,
          product_id,
          pharmacy_id,
          params,
          val,
        })
      }
    },
  },
})
